module.exports = __webpack_public_path__ + "static/media/basic-install.920beff3.png";